/**
 * 返回格式化后的日期时间字符串
 * @example
 * beyond.dateFormat()  // 2014.02.01
 * beyond.dateFormat('yyyy')  // 返回当前时间戳的 2014格式
 * beyond.dateFormat('yyyy',Date.parse(2000))   // 2000
 * beyond.dateFormat(Date.parse(2000))  // 返回该时间戳的默认日期 2000.01.01
 * 
 * year: 年
 * yyyy/yyy   2015
 * yy/y  15
 * yyyyy 02015
 * month :  月
 * 
 * MM 03
 * M 3
 * date :  日
 * dd 09
 * d 9
 * hour :  小时
 * HH 0~24  24格式
 * H 0~24
 * hh 12    12格式
 * h 09
 * minuts :  分
 * mm  
 * m
 * second : 秒
 * ss
 * s
 * week day ： 星期几
 * u
 */


// var months = [
// 	'January',
// 	'February',
// 	'March',
// 	'April',
// 	'May',
// 	'June',
// 	'July',
// 	'August',
// 	'September',
// 	'October',
// 	'November',
// 	'December'
// ],
// shortMonths = [
// 	'Jan', 
// 	'Feb', 
// 	'Mar', 
// 	'Apr', 
// 	'May', 
// 	'June', 
// 	'July', 
// 	'Aug', 
// 	'Sep', 
// 	'Oct', 
// 	'Nov', 
// 	'Dec' 
// ],
import isDate from '../utilities/isDate'

type DateMethods = keyof Pick<Date,'getDate' | 'getHours' | 'getMinutes' | 'getSeconds' | 'getDay'>

var formats : {[key : string] : DateMethods | ((match :string, date : Date)=> string)} = {
	y: function (match : string, date : Date) {
		var year = '' + date.getFullYear()
		if (match.length <= 2) {
			return year.slice(2)
		} else if (match.length > 2 && match.length <= 4) {
			return year
		} else {
			return expandDigit(year, match.length)
		}
	},
	M: function (match : string, date : Date) {
		return expandDigit(date.getMonth() + 1, match.length)
	},
	d: 'getDate',
	H: 'getHours',
	h: function (match : string, date : Date) {
		var h = date.getHours() % 12
		return expandDigit(h, match.length)
	},
	m: 'getMinutes',
	s: 'getSeconds',
	S: function (match : string, date : Date) {
		return date.getMilliseconds() + ''
	},
	u: 'getDay'
},
	formatReg : RegExp,
	formatCodes : string[] = []

for (var k in formats) {
	formatCodes.push(k + '+')
}

formatReg = new RegExp(formatCodes.join('|'), 'g')


function expandDigit(number : number | string, digit : number) {
	let str = String(number)
	var len = str.length
	return len < digit ? (Array(digit - len + 1).join('0') + str) : str
}

function format(match : string, date : Date) {
	var map = formats[match.charAt(0)]
	if (map) {
		return typeof map === 'function' ? map(match, date) : expandDigit(date[map](), match.length)
	} else {
		return match
	}
}

export default function dateFormat(date : Date, formatStr : string) {
	var len = arguments.length
	if (len < 2) {
		throw new TypeError("dateFormat must have two arguments")
	}
	if (!isDate(date)) {
		throw new TypeError('date must be an instance of Date')
	}
	if (typeof formatStr !== 'string') {
		throw new TypeError('formatStr must be string')
	}
	return formatStr.replace(formatReg, function (match) {
		return format(match, date)
	})
}